<div class="card-container"
  [class.vertical]="isVertical"
  [style.background-color]="colorBg"
  (click)="openCategoryProducts()"
>
  <div class="title"><p [style.color]="colorText">{{ name }}</p></div>
  <img [src]="'https://cardapioac.mane.com.vc'+imageUrl" [alt]="name">
</div>
